import React, { useState } from 'react';
import { Card, Form, Button, Row, Col, Alert } from 'react-bootstrap';
import { FaUser, FaLock, FaSave } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';

const Profile = () => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    phone: user?.phone || ''
  });
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleProfileUpdate = (e) => {
    e.preventDefault();
    toast.success('Profile updated (demo)');
  };

  const handlePasswordChange = (e) => {
    e.preventDefault();
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }
    toast.success('Password changed (demo)');
    setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
  };

  return (
    <div>
      <h3 className="mb-4">My Profile</h3>

      <Row>
        <Col md={6}>
          <Card className="mb-4">
            <Card.Header><FaUser /> Profile Information</Card.Header>
            <Card.Body>
              <Form onSubmit={handleProfileUpdate}>
                <Form.Group className="mb-3"><Form.Label>Name</Form.Label><Form.Control value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} /></Form.Group>
                <Form.Group className="mb-3"><Form.Label>Email</Form.Label><Form.Control type="email" value={formData.email} disabled /></Form.Group>
                <Form.Group className="mb-3"><Form.Label>Phone</Form.Label><Form.Control value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} /></Form.Group>
                <Form.Group className="mb-3"><Form.Label>Role</Form.Label><Form.Control value={user?.role?.replace('_', ' ')} disabled /></Form.Group>
                <Button variant="primary" type="submit"><FaSave /> Update Profile</Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card>
            <Card.Header><FaLock /> Change Password</Card.Header>
            <Card.Body>
              <Form onSubmit={handlePasswordChange}>
                <Form.Group className="mb-3"><Form.Label>Current Password</Form.Label><Form.Control type="password" value={passwordData.currentPassword} onChange={(e) => setPasswordData({...passwordData, currentPassword: e.target.value})} required /></Form.Group>
                <Form.Group className="mb-3"><Form.Label>New Password</Form.Label><Form.Control type="password" value={passwordData.newPassword} onChange={(e) => setPasswordData({...passwordData, newPassword: e.target.value})} required /></Form.Group>
                <Form.Group className="mb-3"><Form.Label>Confirm New Password</Form.Label><Form.Control type="password" value={passwordData.confirmPassword} onChange={(e) => setPasswordData({...passwordData, confirmPassword: e.target.value})} required /></Form.Group>
                <Button variant="warning" type="submit"><FaLock /> Change Password</Button>
              </Form>
            </Card.Body>
          </Card>

          <Card className="mt-4">
            <Card.Header>Account Info</Card.Header>
            <Card.Body>
              <Alert variant="info">
                <strong>Credits Available:</strong> {user?.credits || 0}
              </Alert>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Profile;
